import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "./apiService";


const applyAttendanceCorrection = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.leaveManagement.applyAttendanceCorrection}`,
      method: "POST",
      data:params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getAttendanceCorrectionRequest = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.leaveManagement.getAttendanceCorrectionRequest}`,
      method: "GET",
      params:params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const approveRejectAttendanceCorrection = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.leaveManagement.approveRejectAttendanceCorrection}`,
      method: "POST",
      data:params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getAttendanceCorrectionApproval = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.leaveManagement.getAttendanceCorrectionApproval}`,
      method: "GET",
      params:params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const updateAttendanceLog = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.leaveManagement.updateAttendanceLog}`,
      method: "POST",
      data:params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const getAttendanceLogs = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.leaveManagement.getAttendanceLogs}`,
      method: "GET",
      params:params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

    const attendanceCorrectionLogs = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.leaveManagement.attendanceCorrectionLogs}`,
      method: "GET",
      params:params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  export default {
    applyAttendanceCorrection,
    getAttendanceCorrectionRequest,
    approveRejectAttendanceCorrection,
    getAttendanceCorrectionApproval,
    updateAttendanceLog,
    getAttendanceLogs,
    attendanceCorrectionLogs
  }